export default (url) => {
  if (!url) {
    return undefined;
  }
  const parts = url.split('/');
  if (parts.length <= 0) {
    return undefined;
  }

  const lastDirtyPart = parts[parts.length - 1];
  let dirtyIdParts = lastDirtyPart.split('v=');
  dirtyIdParts = dirtyIdParts[dirtyIdParts.length - 1].split('&');
  dirtyIdParts = dirtyIdParts[0].split('?');

  return `https://img.youtube.com/vi/${dirtyIdParts[0]}/default.jpg`;
}



// WEBPACK FOOTER //
// ./src/transforms/ImageFromYoutube.js